var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneOv3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50529 2.39131C11.1828 1.69177 13.8048 0.957036 16.2959 0.262725C18.8592 -0.463562 21.2192 0.331636 22.8366 2.45241C24.4154 4.50438 26.0732 6.67213 27.7931 8.83813C29.5433 11.0813 30.4126 13.9215 29.7752 16.2444C29.1495 18.532 28.3979 20.7777 27.5203 22.9816C26.6259 25.2191 24.2198 26.9712 21.4785 27.7111C18.801 28.4106 16.179 29.1454 13.6879 29.8397C11.1246 30.566 8.76464 29.7708 7.14718 27.65C5.56842 25.598 3.91062 23.4303 2.1907 21.2643C0.440474 19.021 -0.428818 16.1809 0.208582 13.858C0.834264 11.5704 1.58592 9.32466 2.46356 7.12077C3.35795 4.88329 5.76404 3.13121 8.50529 2.39131Z",
    fill: "#FEC106"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneOv3);
export default __webpack_public_path__ + "static/media/bene-ov-3.10a233866cda6fd8df56947b0845346c.svg";
export { ForwardRef as ReactComponent };